module.exports = __webpack_public_path__ + "img/degustation.ebb9a776.jpg";